import { Route, Router, Routes, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import About from './pages/About';
import Upcoming from './pages/Upcoming';
import Media from './pages/Media';
import Donate from './pages/Donate';
import Funders from './pages/Funders';
import Contact from './pages/Contact';
import Landing from './pages/Landing';
import Artists from './pages/Artists';
import HappLab from './pages/HappLab';
import './App.css';

const bgColors = ["#149600", "#f702a5", "#ff3500", "#fcc500", "#ffffff"]
function changeDimensions() {
  const app = document.querySelector(".App")
  app.style.minHeight = `${window.innerHeight}px`
  app.style.minWidth = `${window.innerWidth}px`
}

function randomBg() {
  document.documentElement.style.margin = "0";
  document.documentElement.style.padding = "0";
  document.documentElement.style.width = "100%";
  document.documentElement.style.height = "100%";
  document.body.style.margin = "0";
  document.body.style.padding = "0";
  document.body.style.width = "100%";
  document.body.style.height = "100%";
  const app = document.querySelector(".App")
  app.style.backgroundColor = bgColors[Math.round(Math.random() * bgColors.length)]
}

function App() {
  const location = useLocation()
  useEffect(() => {
    changeDimensions()
    randomBg()
  }, [])
  useEffect(() => {
    randomBg()
  }, [location])


  window.addEventListener("resize", (e) => {
    changeDimensions()
  });

  return (
    <div className="App">
      {/* <Header /> */}
      <main>
        <Routes>
          <Route exact path="/" element={<Landing />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/upcoming" element={<Upcoming />} />
          <Route exact path="/media" element={<Media />} />
          <Route exact path="/artists" element={<Artists />} />
          <Route exact path="/happlab" element={<HappLab />} />
          <Route exact path="/donate" element={<Donate />} />
          <Route exact path="/funders" element={<Funders />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
